// extracted by mini-css-extract-plugin
module.exports = {"hero":"blog-list-module--hero--1ayf3"};